// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"7be8af02","214":"b82d81cf","709":"0f6b1a2f","832":"04f35115"}[chunkId] + ".chunk.js";
};